import { render, staticRenderFns } from "./FormattedMoney.vue?vue&type=template&id=5e4d9a72"
import script from "./FormattedMoney.vue?vue&type=script&lang=ts"
export * from "./FormattedMoney.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports